import React, { useState } from "react";
import { Facebook, MessageCircle, Link2, Check } from "lucide-react";

export function SharePrompt() {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}/register`;
  const text =
    "We just signed up for ARD Midsouth Performance soccer training — Winter Session 1 for ages 7-15 in DeSoto County, MS. Spots are open, register here:";
  const waHref = `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;
  const fbHref = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`${text} ${url}`);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = `${text} ${url}`;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  const btnCls =
    "flex items-center gap-2 border px-5 py-3 font-heading text-xs uppercase tracking-widest transition-colors";

  return (
    <div data-testid="share-prompt" className="mt-8 border-t border-white/10 pt-6">
      <p className="font-body text-xs font-bold uppercase tracking-[0.25em] text-neon-green/80">Know other soccer parents?</p>
      <p className="mt-2 font-body text-sm text-white/60">Help another player find us — share sign-up with one tap:</p>
      <div className="mt-4 flex flex-wrap justify-center gap-2">
        <a href={waHref} target="_blank" rel="noopener noreferrer" data-testid="share-whatsapp" className={`${btnCls} border-neon-green/50 text-neon-green hover:bg-neon-green hover:text-black`}>
          <MessageCircle size={16} strokeWidth={2.5} /> WhatsApp
        </a>
        <a href={fbHref} target="_blank" rel="noopener noreferrer" data-testid="share-facebook" className={`${btnCls} border-white/20 text-white/80 hover:border-neon-green hover:text-neon-green`}>
          <Facebook size={16} strokeWidth={2.5} /> Facebook
        </a>
        <button onClick={copy} data-testid="share-copy" className={`${btnCls} border-white/20 text-white/80 hover:border-neon-green hover:text-neon-green`}>
          {copied ? <Check size={16} strokeWidth={2.5} className="text-neon-green" /> : <Link2 size={16} strokeWidth={2.5} />}
          {copied ? "Copied!" : "Copy Link"}
        </button>
      </div>
    </div>
  );
}
